import script from "./AppointmentRescheduleRequestCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentRescheduleRequestCard.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentRescheduleRequestCard.vue?vue&type=style&index=0&id=2690ebf5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2690ebf5"]])

export default __exports__